<template>
  <div :class="$style.container">
    <div :class="$style.preview">
      <base-icon
        v-p-t="4"
        v-color:black-2
        name="security_safedeal"
      />
    </div>
    <div :class="$style.content">
      <div
        v-m-b="10"
        :class="$style.title"
        v-text="$t('safe.deal.title')"
      ></div>
      <div :class="$style.description">
        {{ $t(displayStatus) }}
      </div>
      <div :class="$style.info" @click="handleClick">
        <base-icon
          v-color:violet
          v-cursor="permission ? 'pointer' : 'default'"
          v-opacity="permission ? 1 : .5"
          name="notifications_question-circle"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { SAFE_DEAL_STATUS_MAP } from 'definitions/transaction';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'TransactionSafeDeal',
  props: {
    deal: {
      type: Object,
      required: true,
    },
    permission: Boolean,
  },
  computed: {
    displayStatus() {
      return SAFE_DEAL_STATUS_MAP[this.deal.status];
    },
  },
  methods: {
    handleClick() {
      if (this.permission) {
        EVENT_BUS.$emit('EVENT_SHOW_SAFE_DEAL_STATUS', this.deal);
      }
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox

  .preview
    +flexbox
    +align-self(flex-start)
    flex: none
    margin-right: 26px

  .content
    flex: 1
    position: relative

  .title
    +font-type('medium', 12, 20)
    color: #212121
    opacity: .5

  .description
    +font-type('semi-bold', 16, 20)
    color: #212121

  .info
    +flexbox
    position: absolute
    top: 50%
    right: 0
    transform: translateY(-50%)
</style>
